export default __webpack_public_path__ + "static/media/1814.a077d20f.png";